import React, { useMemo } from 'react';
import '@/assets/styles/components/unsupported-browser-alert.styles.scss';
import ChromeLogo from '@/assets/images/chrome-logo.webp';
import { ImageWithFallback } from '@/components';
import { isMobile } from 'react-device-detect';

const chromeDownloadLink = 'https://www.google.com/intl/tr_tr/chrome/';

const MESSAGES = {
	mobile: "Bire Bir Uzman'a mobil uygulamamız aracılığıyla erişebilirsiniz.",
	desktop: "Bire Bir Uzman'a yalnızca Google Chrome tarayıcısı üzerinden veya mobil uygulamamız aracılığıyla erişebilirsiniz."
};

const UnsupportedBrowserAlert: React.FC = () => {
	const message = useMemo(() => (isMobile ? MESSAGES.mobile : MESSAGES.desktop), []);

	return (
		<div className={'unsupported-browser-alert'}>
			<ImageWithFallback
				className="unsupported-browser-alert-logo"
				alt="Doping Hafıza Logo"
				src="dh-birebir-logo.svg"
			/>
			<div className={'unsupported-browser-alert-message'}>
				<h1>{message}</h1>
				{!isMobile && (
					<a
						className={'unsupported-browser-alert-message-download-button'}
						href={chromeDownloadLink}
						target={'_blank'}>
						<img
							src={ChromeLogo}
							alt="Google Chrome"
							loading={'lazy'}
						/>
						<span>Google Chrome'u İndir</span>
					</a>
				)}
			</div>
		</div>
	);
};

export default UnsupportedBrowserAlert;
